var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('Card',[_c('SaleStep',{attrs:{"current":_vm.current}}),_c('div',{staticClass:"ticket-list"},[_c('x-table',{attrs:{"columns":_vm.columns,"data":_vm.data}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }